// @file Vuex Store for the electron desktop app
// the electron app makes decisions base on this state.
import currentUser from 'bits/current_user'
import type { User } from 'types'
import { Module } from 'vuex'

interface ElectronAppState {
  currentUser: User | null
  brahmsToken: string
}

const initialState = (): ElectronAppState => {
  return {
    currentUser,
    brahmsToken: '',
  }
}

const electronApp: Module<ElectronAppState, object> = {
  namespaced: true,
  state: initialState(),
  mutations: {
    SET_CURRENT_USER(state, user): void {
      state.currentUser = user
    },
    LOG_OUT(state): void {
      state.currentUser = null
    },
    SET_BRAHMS_TOKEN(state, brahmsToken: string): void {
      state.brahmsToken = brahmsToken
    },
  },
  actions: {
    setCurrentUser({ commit }, user): void {
      commit('SET_CURRENT_USER', user)
    },
    logOut({ commit }): void {
      commit('LOG_OUT')
    },
    setBrahmsToken({ commit }, brahmsToken: string): void {
      commit('SET_BRAHMS_TOKEN', brahmsToken)
    },
  },
}

export { ElectronAppState }
export default electronApp
